import React from 'react';
import Typography from '@mui/material/Typography';

type AppHeaderProps = {
  children: string;
};

const AppHeader = ({ children } : AppHeaderProps) => {
  return ( 
    <Typography
      component="h2"
      variant="h6"
      sx={{
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </Typography>
  );
};

export default AppHeader;
